import React, { useMemo, useState } from 'react';
import { getClientInitials, getClientLogoSources } from '../utils/clientLogo';

/**
 * Client logo with fallbacks: local file → Clearbit (if domain) → initials monogram.
 */
const ClientLogo = ({
  client,
  size = 'md',
  showName = false,
  className = '',
  nameClassName = '',
}) => {
  const sources = useMemo(() => getClientLogoSources(client), [client]);
  const [sourceIndex, setSourceIndex] = useState(0);
  const showImage = sources.length > 0 && sourceIndex < sources.length;

  const boxClass =
    size === 'lg'
      ? 'h-20 w-full'
      : size === 'xs'
        ? 'h-12 w-full'
      : size === 'sm'
        ? 'h-10 w-10'
        : 'h-16 w-full';

  const imgClass =
    size === 'lg'
      ? 'max-h-[4.5rem] max-w-[90%]'
      : size === 'xs'
        ? 'max-h-10 max-w-[90%]'
      : size === 'sm'
        ? 'max-h-8 max-w-8'
        : 'max-h-14 max-w-[85%]';

  const initialsClass =
    size === 'lg'
      ? 'h-16 w-16 text-xl'
      : size === 'xs'
        ? 'h-10 w-10 text-sm'
      : size === 'sm'
        ? 'h-10 w-10 text-sm'
        : 'h-14 w-14 text-lg';

  return (
    <div className={`flex flex-col items-center ${className}`}>
      <div className={`flex items-center justify-center ${boxClass}`}>
        {showImage ? (
          <img
            src={sources[sourceIndex]}
            alt={`${client.name} logo`}
            className={`object-contain ${imgClass}`}
            loading="lazy"
            decoding="async"
            onError={() => setSourceIndex((i) => i + 1)}
          />
        ) : (
          <div
            className={`flex shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-brand-50 to-brand-100 font-heading font-bold text-brand-800 ring-1 ring-brand-200/60 ${initialsClass}`}
            aria-hidden
          >
            {getClientInitials(client.name)}
          </div>
        )}
      </div>
      {showName && (
        <p className={`mt-2 text-center font-heading font-bold uppercase leading-snug tracking-wide text-neutral-900 ${size === 'xs' ? 'text-[10px]' : 'text-xs'} ${nameClassName}`}>
          {client.name}
        </p>
      )}
    </div>
  );
};

export default ClientLogo;
